import React, { useState } from 'react'

import {
  Grid, Card, CardActionArea, CardContent, CardActions,
  Dialog, DialogTitle, Avatar, Typography, Button, List, ListItem, ListItemAvatar, ListItemText, Divider
} from '@material-ui/core'

import AvatarGroup from '@material-ui/lab/AvatarGroup'

const GroupSupervisorDialog = (props) => {
  const { groupInfo, classes, checkGroup, handleGroupClick } = props
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <Grid container item direction='row' className='mx-auto w-100 mb-2'>
        <Card raised className={`${classes.groupCard} ${checkGroup(groupInfo.groupID)}`}>
          <CardActionArea onClick={() => handleGroupClick(groupInfo.groupID)} className={classes.groupAction}>
            <CardContent className='pb-0'>
              <Grid container direction='row'>
                <Grid container item direction='column' className='m-auto w-100' spacing={2}>
                  <Grid container item direction='row' alignItems='center' className='w-100 m-auto p-0' spacing={2}>
                    <AvatarGroup max={4} spacing='medium' className='mx-auto' classes={{ avatar: classes.avatarGroup }}>
                      {
                        groupInfo.supervisors.map((supervisorInfo) => (
                          <Avatar key={`group-supervisor-${supervisorInfo.supervisorID}`} src={supervisorInfo.avatarPath} className={classes.groupAvatar}>
                            {supervisorInfo.avatarPath ? (<></>) : supervisorInfo.firstName.substring(0, 1)}{supervisorInfo.lastName.substring(0, 1)}
                          </Avatar>
                        ))
                      }
                    </AvatarGroup>
                  </Grid>
                  <Grid container item direction='row' justify='center'>
                    <Typography align='center' variant='button'>{groupInfo.groupName}</Typography>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </CardActionArea>
          <CardActions className='pt-0'>
            <Grid container direction='row' justify='center'>
              <Grid item>
                <Button
                  variant='text'
                  className={classes.viewBtn}
                  onClick={() => setIsOpen(true)}
                >
                  View Group
                </Button>
              </Grid>
            </Grid>
          </CardActions>
        </Card>
      </Grid>

      <Dialog onClose={() => setIsOpen(false)} open={isOpen}>
        <DialogTitle disableTypography>
          <Typography variant='h6' component='h2' align='center'>
            <span className='font-weight-bold'>Group: </span>{groupInfo.groupName}
          </Typography>
        </DialogTitle>

        <Divider variant='middle' className={classes.groupDivider} />
        <List className={classes.groupList}>
          {
            groupInfo.supervisors.map((supervisorInfo) => (
              <ListItem key={`group-supervisor-dialog-${supervisorInfo.supervisorID}`}>
                <ListItemAvatar>
                  <Avatar src={supervisorInfo.avatarPath} className={classes.groupAvatar}>
                    {supervisorInfo.avatarPath ? (<></>) : supervisorInfo.firstName.substring(0, 1)}{supervisorInfo.lastName.substring(0, 1)}
                  </Avatar>
                </ListItemAvatar>

                <ListItemText
                  primary={`${supervisorInfo.firstName} ${supervisorInfo.lastName}`}
                  primaryTypographyProps={{ variant: 'button' }}
                />
              </ListItem>
            ))
          }
        </List>
      </Dialog>
    </>
  )
}

export default GroupSupervisorDialog
